module.exports = __webpack_public_path__ + "img/gift1-nl.f605eee5.jpg";